import React, { useEffect } from 'react';
import { Check, IconContext } from '@phosphor-icons/react';

const Menu = (props) => {
  const {
    menuItems,
    onClick,
    value,
    isMultiSelect,
    dropdownRef,
    onBlur,
    width,
    showSelection,
  } = props;

  useEffect(() => {
    const clickListener = (e) => {
      if (!dropdownRef?.current?.contains(e?.target)) onBlur();
    };

    document.addEventListener('click', clickListener);

    return () => document.removeEventListener('click', clickListener);
  }, []);

  return (
    <div
      className="menu-wrapper absolute"
      {...(width && ({ style: { width } }))}
    >
      {menuItems?.length ? (
        menuItems?.map((menu, index) => (
          <>
            <div
              className="menu-item flex items-center justify-between p-5"
              key={menu?.id}
              onClick={(e) => onClick(menu, e)}
            >
              {menu?.label}
              {(showSelection && (isMultiSelect && value?.includes(menu?.id) || value === menu?.id)) && (
                <Check size={24}
                  color="#D92D20" />
              )}
              {menu?.icon && (
                <IconContext.Provider
                  value={{
                    size: 24,
                    weight: 'bold',
                    ...menu?.iconProps,
                  }}
                >
                  <div className="menu-icon">
                    {menu.icon}
                  </div>
                </IconContext.Provider>)}
            </div>
            {(index !== (menuItems?.length - 1)) && (<div className="divider w-full" />)}
          </>
        ))) : (
        <div className="text-14 p-4 text-center">No Options</div>
      )}
    </div>
  );
};

export default Menu;
